import { useLocation } from 'react-router-dom'
import { createContext, useContext, useEffect, useState, ReactNode } from 'react'

type NavigationHistoryContextType = Array<string>

const NavigationHistoryContext = createContext<NavigationHistoryContextType | undefined>(undefined)

const Provider = ({ children }: { children: ReactNode }) => {
  const location = useLocation()
  const [history, setHistory] = useState<Array<string>>(() => {
    const storedHistory = sessionStorage.getItem('navHistory')
    return storedHistory ? JSON.parse(storedHistory) : []
  })

  useEffect(() => {
    setHistory((prevHistory) => {
      const newHistory = [...prevHistory, location.pathname]

      if (newHistory.length > 3) {
        newHistory.shift()
      }

      sessionStorage.setItem('navHistory', JSON.stringify(newHistory))
      return newHistory
    })
  }, [location])

  return <NavigationHistoryContext.Provider value={history}>{children}</NavigationHistoryContext.Provider>
}

export function useNavigationHistory() {
  const context = useContext(NavigationHistoryContext)

  if (context === undefined) {
    throw new Error('useNavigationHistory must be used within a NavigationHistoryProvider')
  }

  return context
}

const NavigationHistoryProvider = {
  Provider,
  Consumer: NavigationHistoryContext.Consumer
}

export default NavigationHistoryProvider
